import FormattedMessage from 'I18n/components/FormattedMessage';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const EnrollmentSaveButton = ({
  allowSave,
  label,
  onSave,
  saveDisabledMessage,
  saveFailed,
  savePending,
  use = 'primary',
  size = 'medium',
  dataTestId
}) => {
  return /*#__PURE__*/_jsx(UITooltip, {
    "data-test-id": "automation-enrollment-save-button-disabled-tooltip",
    placement: "top",
    title: saveDisabledMessage,
    disabled: allowSave,
    children: /*#__PURE__*/_jsx(UILoadingButton, {
      use: use,
      size: size,
      onClick: onSave,
      disabled: !allowSave,
      loading: savePending,
      responsive: false,
      resultIcon: saveFailed ? 'remove' : 'success',
      "data-test-id": dataTestId || 'automation-enrollment-save-button',
      children: label || /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-enrollment.redesign.saveButton.defaultLabel"
      })
    })
  });
};
export default EnrollmentSaveButton;